import React, { createContext, useState, useContext, useCallback } from 'react';

export const TopBarLeftContentContext = createContext();

export const useTopBarLeftContent = () => {
  const context = useContext(TopBarLeftContentContext);
  if (!context) {
    throw new Error('useTopBarLeftContent debe usarse dentro de TopBarLeftContentProvider');
  }
  return context;
};

export const TopBarLeftContentProvider = ({ children }) => {
  const [leftContent, setLeftContent] = useState(null);
  const [isBrandSelectorVisible, setBrandSelectorVisible] = useState(true);

  const registerContent = useCallback((content) => {
    setLeftContent(content);
  }, []);

  const clearContent = useCallback(() => {
    setLeftContent(null);
  }, []);

  const setBrandSelectorVisibility = useCallback((visible) => {
    setBrandSelectorVisible(Boolean(visible));
  }, []);

  return (
    <TopBarLeftContentContext.Provider
      value={{
        leftContent,
        registerContent,
        clearContent,
        isBrandSelectorVisible,
        setBrandSelectorVisibility,
      }}
    >
      {children}
    </TopBarLeftContentContext.Provider>
  );
};
